import {useUpdateHeaderTitle, usePermission} from "../hooks";
import {ExtraButtons} from "../components/extra-buttons";
import {Header} from "../components/layout/header";
import {TableSearch} from "../components/table-search";
import React from "react";
import {getColumns} from "../pages-lib/banners/table-columns";
import {useGetData, useManageItems} from "../pages-lib/banners/model";
import styled from "styled-components";
import {Table as AntTable} from "antd";
import {VisibilityProvider} from "../components/visibility-provider";
import {EditDrawer} from "../pages-lib/banners/edit-drawer";

export default function Banners() {
    const [createDrawerState, setCreateDrawerState] = React.useState(false)
    const [editDrawerState, setEditDrawerState] = React.useState(false)

    const headerTitle = useUpdateHeaderTitle({
        items: [],
        defaultTitle: "0 Баннеров",
        arrType: ["Баннер", "Баннера", "Баннеров"],
    })

    const {
        dataBanners,
        pagination,
        isLoading,
        handleTableChange,
        handleSearchTable,
        refetch: getItems
    } = useGetData()

    const { hasPermission } = usePermission()

    const {
        editData,
        onSaveEdit,
        onCreate,
        resetData,
        onDelete,
        onEditItem
    } = useManageItems(dataBanners, getItems, onSuccessEdit, onSuccessCreate)

    function onSuccessEdit() {
        setEditDrawerState(!editDrawerState)
    }

    function onSuccessCreate() {
        setCreateDrawerState(!createDrawerState)
    }

    const columns = getColumns(hasPermission("banners.edit") ? onEditItem : null, hasPermission("banners.delete") ? onDelete : null)

    return (
        <>
            <Header
                title={headerTitle}
                extra={
                    <ExtraButtons
                        onCreate={hasPermission("banners.create") ? () => setCreateDrawerState(true) : undefined}
                        // onFilter={() => setFilterDrawerState(!filterDrawerState)}
                        // onSort={() => setSortableDrawerState(!sortableDrawerState)}
                        titles={{ onCreate: "Добавить баннер" }}
                    />
                }
            />

            <TableSearch handleSearch={handleSearchTable} placeholder={"Поиск по ID или заголовку"} />

            <StyledTable
                dataSource={dataBanners}
                columns={columns}
                loading={isLoading}
                onChange={handleTableChange}
                pagination={pagination}
            />

            {hasPermission("banners.create") && (
                <VisibilityProvider visible={createDrawerState}>
                    <EditDrawer
                        title={"Создание баннера"}
                        onSave={onCreate}
                        onClose={() => setCreateDrawerState(!createDrawerState)}
                        initialValues={false}
                    />
                </VisibilityProvider>
            )}

            {hasPermission("banners.edit") && (
                <VisibilityProvider visible={editDrawerState}>
                    <EditDrawer
                        title={"Редактирование баннера"}
                        onSave={onSaveEdit}
                        onClose={() => {
                            setEditDrawerState(!editDrawerState)
                            resetData()
                        }}
                        initialValues={editData}
                    />
                </VisibilityProvider>
            )}

        </>
    )
}

const StyledTable = styled(AntTable)`
  .row-can-view {
    cursor: pointer;
  }
`
